import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

/**
 * Renders a markdown string (GFM — tables, lists, etc.) with theme-token styling
 * applied via descendant variants, so it follows light/dark without hardcoded
 * colors. Used to preview indexed chunks as formatted text instead of raw mono.
 */
export function MarkdownPreview({ content }: { content: string }) {
  return (
    <div
      className={[
        'overflow-x-auto px-2.5 py-2 text-[12px] leading-relaxed text-foreground',
        '[&_p]:my-2 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
        'max-md:[&_p]:break-words max-md:[&_li]:break-words',
        '[&_h1]:mt-3 [&_h1]:mb-1 [&_h1]:font-semibold [&_h1]:text-sm',
        '[&_h2]:mt-3 [&_h2]:mb-1 [&_h2]:font-semibold [&_h2]:text-sm',
        '[&_h3]:mt-2 [&_h3]:mb-1 [&_h3]:font-medium [&_h3]:text-sm',
        '[&_ul]:my-2 [&_ul]:ml-4 [&_ul]:list-disc [&_ol]:my-2 [&_ol]:ml-4 [&_ol]:list-decimal',
        '[&_li]:mt-0.5 [&_li]:marker:text-muted-foreground',
        '[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2',
        '[&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-border [&_blockquote]:pl-3 [&_blockquote]:text-muted-foreground [&_blockquote]:italic',
        '[&_hr]:my-3 [&_hr]:border-border',
        '[&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.85em]',
        '[&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:border [&_pre]:border-border [&_pre]:bg-muted/40 [&_pre]:p-2',
        '[&_table]:my-2 [&_table]:w-full [&_table]:border-collapse [&_table]:text-[11px]',
        '[&_th]:border [&_th]:border-border [&_th]:bg-muted [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:font-medium [&_th]:text-foreground',
        '[&_td]:border [&_td]:border-border [&_td]:px-2 [&_td]:py-1 [&_td]:align-top',
      ].join(' ')}
    >
      <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
    </div>
  )
}
